import {
  ClaimsAdvice,
  VesselSpecificClaimsAdvice,
} from '../../../models/pro.model';
import { getApplicableVesselTypesDisplay } from '../../../utils/pro-report-helpers.utils';
import { hasApplicableVesselTypes } from '../pro-report-email-export-helpers';

import { tableSubHeaderColour, tableWidth } from '../pro-report-email-styles';
import {
  ProReportEmailFullWidthInfoRow,
  ProReportEmailFullWidthTableHeader,
} from './pro-report-email-common-components';
import ProReportEmailNoDataPlaceHolder from './pro-report-email-no-data';

function ProReportEmailLossPreventionCommentary({
  claimsAdvice,
}: {
  claimsAdvice: ClaimsAdvice[] | VesselSpecificClaimsAdvice[];
}) {
  const headerText = 'Loss prevention commentary';

  if (claimsAdvice && claimsAdvice.length > 0) {
    return (
      <table
        width={tableWidth}
        cellPadding={0}
        cellSpacing={0}
        style={{ borderCollapse: 'collapse', margin: 0, padding: 0 }}
        role="presentation"
      >
        <ProReportEmailFullWidthTableHeader headerText={headerText} />

        {claimsAdvice.length > 0 &&
          claimsAdvice.map((item) => (
            <tbody>
              {hasApplicableVesselTypes(item) && (
                <ProReportEmailFullWidthInfoRow
                  key={item.applicable_vessel_types?.join('-')}
                  heading="Applicable vessel types:"
                  content={getApplicableVesselTypesDisplay(
                    item.applicable_vessel_types
                  )}
                  backgroundColor={tableSubHeaderColour}
                />
              )}
              <ProReportEmailFullWidthInfoRow
                heading="Summary:"
                content={item.summary}
              />
              <ProReportEmailFullWidthInfoRow
                heading="Advice:"
                content={item.advice ?? 'No advice provided.'}
              />
            </tbody>
          ))}
      </table>
    );
  }
  return (
    <ProReportEmailNoDataPlaceHolder
      header={headerText}
      subHeading=""
      content="No advice provided."
    />
  );
}

export default ProReportEmailLossPreventionCommentary;
